<template>
    <font-awesome-icon :spin="true" icon="spinner"/>
</template>
<script>
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

    export default {
        components: {FontAwesomeIcon},
        name: "FaSpinner"
    }
</script>
